import useFetchWDACScriptExecution from './useFetchWDACScriptExecution';
import WdacScriptExecutionTable from './WdacScriptExecutionTable';

const WdacScriptExecution = () => {
  const {
    isLoading,
    data: scriptExecutionList,
    lastElementRef,
    isFetching,
    totalCount,
    query,
  } = useFetchWDACScriptExecution();

  return (
    <WdacScriptExecutionTable
      isLoading={isLoading}
      isFetching={isFetching}
      scriptExecutionList={scriptExecutionList}
      lastElementRef={lastElementRef}
      totalCount={totalCount}
      query={query}
    />
  );
};

export default WdacScriptExecution;
